import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';

const store = createPinia();
store.use(createPersistedState());

export { store };

export * from './modules/department';
export * from './modules/inventory-order';
export * from './modules/notification';
export * from './modules/order';
export * from './modules/permission';
export * from './modules/role';
export * from './modules/setting';
export * from './modules/tabs-router';
export * from './modules/user';

export default store;
